// src/templates/empanadaclub/DashboardHeader.jsx
// DashboardHeader personalizado para empanadaclub
// Muestra: ¡Hola! Bienvenido NOMBRE DEL USUARIO

import React, { useState, useEffect } from 'react';
import useAuthStore from '../../store/authStore';
import { get } from '../../helpers/apiHelper';

const DashboardHeader = () => {
    const { user } = useAuthStore();
    const [userName, setUserName] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserName = async () => {
            if (!user?.userId) {
                setLoading(false);
                return;
            }

            try {
                const userData = await get(`users/${user.userId}`);
                if (userData) {
                    // Intentar obtener nombre completo
                    if (userData.nombre && userData.apellido) {
                        const capitalize = (str) => {
                            return str.replace(/\b\w/g, char => char.toUpperCase());
                        };
                        setUserName(capitalize(`${userData.nombre} ${userData.apellido}`));
                    } else if (userData.nombre) {
                        const capitalize = (str) => {
                            return str.replace(/\b\w/g, char => char.toUpperCase());
                        };
                        setUserName(capitalize(userData.nombre));
                    } else if (userData.email) {
                        // Si no hay nombre, usar el email como fallback
                        setUserName(userData.email.split('@')[0]);
                    } else {
                        setUserName('Usuario');
                    }
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                setUserName('Usuario');
            } finally {
                setLoading(false);
            }
        };

        fetchUserName();
    }, [user]);

    if (loading) {
        return (
            <header className="mb-6 sm:mb-8">
                <div className="text-center mb-4 sm:mb-6">
                    <div className="h-8 sm:h-10 bg-gray-200 rounded animate-pulse mx-auto max-w-md"></div>
                </div>
            </header>
        );
    }

    return (
        <header className="mb-4 sm:mb-6 md:mb-8">
            <div className="text-center mb-3 sm:mb-4 md:mb-6 px-2 sm:px-4">
                <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-2 break-words leading-tight">
                    ¡Hola! Bienvenido {userName}
                </h1>
            </div>
        </header>
    );
};

export default DashboardHeader;

